import styled from 'styled-components';
import { IconArrowUp, IconArrowDown, IconSort } from '../Icon/index';
export var StyledIconArrowDown = /*#__PURE__*/styled(IconArrowDown).withConfig({
  displayName: "StyledIconArrowDown",
  componentId: "c11n-8-64-0__sc-1fv8tdd-0"
})([""]);
export var StyledIconArrowUp = /*#__PURE__*/styled(IconArrowUp).withConfig({
  displayName: "StyledIconArrowUp",
  componentId: "c11n-8-64-0__sc-1fv8tdd-1"
})([""]);
export var StyledIconSort = /*#__PURE__*/styled(IconSort).withConfig({
  displayName: "StyledIconSort",
  componentId: "c11n-8-64-0__sc-1fv8tdd-2"
})([""]);
export var StyledSortIconWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledSortIconWrapper",
  componentId: "c11n-8-64-0__sc-1fv8tdd-3"
})([""]);
export var StyledTableHeaderCellLabelWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledTableHeaderCellLabelWrapper",
  componentId: "c11n-8-64-0__sc-1fv8tdd-4"
})([""]);